import React from "react";
import styles from "./Message.module.scss";
import WarningIcon from '../../assets/icons/16/warning.svg'
import {MessagePropsInterface} from "./Message.props.interface";

const Message: React.FC<MessagePropsInterface> = (
    {
        type = 'danger',
        children = undefined,
    }) => {

    return (
        <div className={[
            styles.container,
            styles[type]
        ].filter(x => x ?? x).join(' ')}>
            {type === 'danger' ? <WarningIcon/> : null}
            {children}
        </div>
    )
};

export default Message;
